import { type OcrResult } from "@finway-group/shared/lib/models"
import moment from "moment"
import React from "react"
import { EInvoiceDetails } from "~Components/einvoice/components/Details"
import { EInvoiceFooter } from "~Components/einvoice/components/Footer"
import { EInvoiceHeader } from "~Components/einvoice/components/Header"
import { EInvoiceItems } from "~Components/einvoice/components/Items"
import { EInvoiceNote } from "~Components/einvoice/components/Note"
import { EInvoicePaymentTerms } from "~Components/einvoice/components/PaymentTerms"
import { EInvoiceSummary } from "~Components/einvoice/components/Summary"
import { EInvoiceVatBreakdown } from "~Components/einvoice/components/VatBreakdown"
import { getInvoiceTypeLabel } from "../utils/helpers"

interface EInvoiceXmlRendererProps {
    data: OcrResult
}

export const EInvoiceXmlRenderer = ({ data }: EInvoiceXmlRendererProps) => {
    if (!data.eInvoiceData) {
        return null
    }

    const invoiceTypeCode = Number(data.eInvoiceData?.invoiceTypeCode)
    const invoiceTypeLabel = getInvoiceTypeLabel(invoiceTypeCode)
    const formattedDate = moment(data?.invoiceDate).format("DD.MM.YYYY")

    return (
        <div className="h-full w-full my-20 p-20">
            <div className="max-w-5xl mx-auto flex flex-col gap-20">
                <EInvoiceHeader invoiceTypeLabel={invoiceTypeLabel} invoiceTypeCode={invoiceTypeCode} invoiceNumber={data.invoiceNumber} invoiceDate={formattedDate} />
                <EInvoiceDetails data={data} />
                <EInvoiceItems data={data} />
                <EInvoiceVatBreakdown data={data} />
                <EInvoiceSummary data={data} />
                <EInvoicePaymentTerms data={data} />
                <EInvoiceNote data={data} />
                <EInvoiceFooter />
            </div>
        </div>
    )
}
